import React from 'react';
import { BaseFacet } from './BaseFacet';

interface AlphabeticalFacetProps {
  field: string;
  label: string;
  show?: number;
  otherAtBottom?: boolean;
}

export const AlphabeticalFacet: React.FC<AlphabeticalFacetProps> = (props) => {
  return <BaseFacet {...props} sortType="alphabetical" />;
};
